// import React, { useRef, useState, useEffect } from "react";
// import {
//   Box,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   Grid,
//   Typography,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   FormHelperText,
// } from "@mui/material";
// import { useReactToPrint } from "react-to-print";
// import { useForm, Controller } from "react-hook-form";
// import CloseIcon from "@mui/icons-material/Close";
// import styles from "../../../styles.module.css";
// import {
//   Breadcrumb,
//   CTSinput,
//   CTSRinput,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import HeaderSection from "../../reusableComponent/HeaderSection";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import daily_distribution_reportService from "../../../services/report/daily_distribution_report.Service";

// const DailyDistributionReport = () => {
//   const printRef = useRef();
//   const [searchKey, setSearchKey] = useState("");
//   const [rows, setRows] = useState([]);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [openDetail, setOpenDetail] = useState(false);
//   const [dialogData, setDialogData] = useState([]);
//   const [dialogTitle, setDialogTitle] = useState("");
//   const [total_count, setTotalCount] = useState(null);
//   const [depots, setDepots] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [filterType, setFilterType] = useState("");
//   const [subBoxValue, setSubBoxValue] = useState("");
//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: 10,
//   });

//   const filterOptions = [
//     { value: "depot", label: "Depot" },
//     { value: "product_code", label: "Product" },
//     { value: "customer_name", label: "Customer" },
//   ];

//   const subBoxOptions = filterType
//     ? {
//       depot: depots.map((depot) => ({ value: depot, label: depot })),
//       product_code: products.map((product) => ({ value: product, label: product })),
//       customer_name: customers.map((customer) => ({ value: customer, label: customer })),
//     }[filterType] || []
//     : [];

//   const { control, watch, setValue, formState: { errors } } = useForm({
//     defaultValues: {
//       entry_date_from: "",
//       entry_date_to: "",
//       filterType: "",
//       subBox: "",
//     },
//     resolver: (data) => {
//       const errors = {};
//       if (data.entry_date_from && data.entry_date_to) {
//         if (new Date(data.entry_date_to) < new Date(data.entry_date_from)) {
//           errors.entry_date_to = { message: "To Date cannot be before From Date" };
//         }
//       }
//       return { values: data, errors };
//     },
//   });

//   const entry_date_from = watch("entry_date_from");
//   const entry_date_to = watch("entry_date_to");
//   const selectedFilterType = watch("filterType");
//   const selectedSubBox = watch("subBox");

//   const subFilterLabel = filterOptions.find((option) => option.value === selectedFilterType)?.label || "Sub Filter";

//   useEffect(() => {
//     setTotalCount(rows[0]?.totalCount || 0);
//   }, [rows]);

//   const fetchData = async () => {
//     try {
//       const params = {
//         page: controller.page,
//         size: controller.rowsPerPage,
//         searchKey: searchKey,
//         entry_date_from: entry_date_from || undefined,
//         entry_date_to: entry_date_to || undefined,
//         filterType: selectedFilterType || undefined,
//         subBox: selectedSubBox || undefined,
//       };
//       const response = await daily_distribution_reportService.getdailydistributionrepotlist(params);
//       setRows(response);

//       const uniqueDepots = [...new Set(response.map((row) => row.depot))].filter(Boolean);
//       const uniqueProducts = [...new Set(response.map((row) => row.product_code))].filter(Boolean);
//       const uniqueCustomers = [...new Set(response.map((row) => row.customer_name))].filter(Boolean);
//       setDepots(uniqueDepots);
//       setProducts(uniqueProducts);
//       setCustomers(uniqueCustomers);
//     } catch (error) {
//       setSuccessMessage("Error fetching data");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [controller.page, controller.rowsPerPage, searchKey, entry_date_from, entry_date_to, selectedFilterType, selectedSubBox]);

//   const handleCountClick = (row) => {
//     setDialogData(row.cylinders || []);
//     setDialogTitle(`Cylinder Details for location ${row.depot}`);
//     setOpenDetail(true);
//   };

//   const handleClose = () => {
//     setOpenDetail(false);
//     setDialogData([]);
//     setDialogTitle("");
//   };

//   const handleChangePage = (event, newPage) => {
//     setController((prev) => ({ ...prev, page: newPage }));
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setController({
//       page: 0,
//       rowsPerPage: parseInt(event.target.value, 10),
//     });
//   };

//   const handleSearch = (e) => {
//     setSearchKey(e.target.value);
//     setController((prev) => ({ ...prev, page: 0 }));
//   };

//   const printFunction = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: "Daily Distribution Report",
//     removeAfterPrint: true,
//   });

//   const handlePrint = () => {
//     printFunction();
//   };

//   const filteredRows = rows.filter((row) => {
//     const rowDate = new Date(row.entry_date);
//     const fromDate = entry_date_from ? new Date(entry_date_from) : null;
//     const toDate = entry_date_to ? new Date(entry_date_to) : null;

//     const dateMatch = !fromDate || !toDate || (rowDate >= fromDate && rowDate <= toDate);
//     const filterMatch = !selectedFilterType || !selectedSubBox || row[selectedFilterType] === selectedSubBox;

//     return dateMatch && filterMatch;
//   });

//   const start = controller.page * controller.rowsPerPage;
//   const end = start + controller.rowsPerPage;
//   const paginatedRows = filteredRows.slice(start, end);
//   const paginationInfo = `${start + 1}-${Math.min(end, filteredRows.length)} of ${filteredRows.length}`;

//   const formatDate = (date) => {
//     if (!date) return "-";
//     return new Date(date).toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });
//   };

//   return (
//     <Box className={styles.cts_page}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: "Daily Distribution Report" }]} />

//         <HeaderSection
//           title="DAILY DISTRIBUTION REPORT"
//           searchKey={searchKey}
//           handleSearch={handleSearch}
//           sortedRows={rows}
//           fields={[]}
//           labels={[]}
//           filename="Daily Distribution Report"
//           paginationInfo={paginationInfo}
//           controller={controller}
//           handleChangePage={handleChangePage}
//           showAddButton={false}
//           PrintIcon_print={{ onClick: handlePrint }}
//         />

//         <form className="no-print">
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography className={styles.label_Txt_add}>From Date</Typography>
//                 <Controller
//                   name="entry_date_from"
//                   control={control}
//                   render={({ field }) => (
//                     <CTSRinput
//                       {...field}
//                       size="small"
//                       fullWidth
//                       type="date"
//                       InputLabelProps={{ shrink: true }}
//                       error={!!errors.entry_date_from}
//                       helperText={errors.entry_date_from?.message}
//                      InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography className={styles.label_Txt_add}>To Date</Typography>
//                 <Controller
//                   name="entry_date_to"
//                   control={control}
//                   render={({ field }) => (
//                     <CTSRinput
//                       {...field}
//                       size="small"
//                       fullWidth
//                       type="date"
//                       InputLabelProps={{ shrink: true }}
//                       error={!!errors.entry_date_to}
//                       helperText={errors.entry_date_to?.message}
//                      InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography className={styles.label_Txt_add}>Filter By</Typography>
//                 <Controller
//                   name="filterType"
//                   control={control}
//                   render={({ field }) => (
//                     <FormControl fullWidth size="small" error={!!errors.filterType} sx={{ ml: 1 }}>
//                       <CTSinput
//                          select
//                         {...field}
//                         onChange={(e) => {
//                           field.onChange(e);
//                           setFilterType(e.target.value);
//                           setSubBoxValue("");
//                           setValue("subBox", "");
                          
//                         }}
//                                 InputProps={{
                                                                              
//                                                                               className: styles.CTSinput_Box,
//                                                                             }}
//                       >
//                         <MenuItem value="">
//                           <em>Select Filter</em>
//                         </MenuItem>
//                         {filterOptions.map((option) => (
//                           <MenuItem key={option.value} value={option.value}>
//                             {option.label}
//                           </MenuItem>
//                         ))}
//                       </CTSinput>
//                       <FormHelperText>{errors.filterType?.message}</FormHelperText>
//                     </FormControl>
//                   )}
//                 />
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography className={styles.label_Txt_add}>{subFilterLabel}</Typography>
//                 <Controller
//                   name="subBox"
//                   control={control}
//                   render={({ field }) => (
//                     <FormControl fullWidth size="small" error={!!errors.subBox} disabled={!filterType} sx={{ ml: 1 }}>
//                       <CTSinput
//                         select
//                         {...field}
//                         onChange={(e) => {
//                           field.onChange(e);
//                           setSubBoxValue(e.target.value);
//                         }}
//                           InputProps={{
                                                                              
//                                                                               className: styles.CTSinput_Box,
//                                                                             }}
//                       >
//                         <MenuItem value="">
//                           <em>Select Option</em>
//                         </MenuItem>
//                         {subBoxOptions.map((option) => (
//                           <MenuItem key={option.value} value={option.value}>
//                             {option.label}
//                           </MenuItem>
//                         ))}
//                       </CTSinput>
//                       <FormHelperText>{errors.subBox?.message}</FormHelperText>
//                     </FormControl>
//                   )}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </form>

//         <Box
//           ref={printRef}
//           sx={{
//             display: "none",
//             "@media print": {
//               display: "block",
//             },
//             backgroundColor: "#fff",
//             padding: 2,
//           }}
//         >
//           <h2 style={{ textAlign: "left", marginBottom: 12 }}>
//             Daily Distribution Report
//           </h2>
//           <p style={{ textAlign: "left", fontSize: 12, marginBottom: 20 }}>
//             Generated on: {new Date().toLocaleDateString()}
//           </p>

//           <Table size="small" stickyHeader>
//             <TableHead>
//               <StyledTableRow>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Issuing Depot</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Date</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Name of Customer</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Product Name</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Product Code</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Po Qty</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Del Qty</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>No of Cylinders</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Invoice No</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Flag</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Challan No</StyledTableCell>
//                 <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Challan Date</StyledTableCell>
//               </StyledTableRow>
//             </TableHead>
//             <TableBody>
//               {filteredRows.map((row, index) => (
//                 <StyledTableRow key={index}>
//                   <StyledTableCell align="left" >{row.depot || row.issuing_depot || "-"}</StyledTableCell>
//                   <StyledTableCell align="left">{formatDate(row.entry_date)}</StyledTableCell>
//                   <StyledTableCell align="left" sx={{ width: "20px" }}> <Typography sx={{
//                         width: '100%',
//                         maxWidth: '100%',
//                         whiteSpace: 'normal',
//                         wordBreak: 'break-word',
//                       }}
//                       className={styles.inspection_cell}> {row.customer_name || "-"}</Typography></StyledTableCell>
//                   <StyledTableCell align="left">{row.product_name || "-"}</StyledTableCell>
//                   <StyledTableCell align="left">{row.product_code || "-"}</StyledTableCell>
//                   <StyledTableCell align="left">{Number(row.po_qty || row.qty || 0).toFixed(2)}</StyledTableCell>
//                   <StyledTableCell align="left">{row.del_qty || 0}</StyledTableCell>
//                   <StyledTableCell align="left">{row.no_of_cylinders || 0}</StyledTableCell>
//                   <StyledTableCell align="left">{row.invoice_no || "-"}</StyledTableCell>
//                   <StyledTableCell isCancelled={row.update_check === 1}>{row.update_check === 1 ? 'cancelled' : ''}
//                   </StyledTableCell>

//                   <StyledTableCell align="left">{row.challan_no || "-"}</StyledTableCell>
//                   <StyledTableCell align="left">{formatDate(row.challan_date) || "-"}</StyledTableCell>
//                 </StyledTableRow>
//               ))}
//             </TableBody>
//           </Table>

//         </Box>

//         <Paper sx={{ width: "100%" }}>
//           <TableContainer component={Paper} className={styles.list_tbl_container}>
//             <Table size="small" stickyHeader>
//               <TableHead>
//                 <StyledTableRow>
//                   <StyledTableCell align="left">Issuing Depot</StyledTableCell>
//                   <StyledTableCell align="left">Date</StyledTableCell>
//                   <StyledTableCell align="left"   >Name of Customer</StyledTableCell>
//                   <StyledTableCell align="left">Product Name</StyledTableCell>
//                   <StyledTableCell align="left">Product Code</StyledTableCell>
//                   <StyledTableCell align="left">Po Qty</StyledTableCell>
//                   <StyledTableCell align="left">Del Qty</StyledTableCell>
//                   <StyledTableCell align="left">No of Cylinders</StyledTableCell>
//                   <StyledTableCell align="left">Invoice No</StyledTableCell>
//                   <StyledTableCell align="left">Flag</StyledTableCell>
//                   <StyledTableCell align="left">Challan No</StyledTableCell>
//                   <StyledTableCell align="left">Challan Date</StyledTableCell>
//                 </StyledTableRow>
//               </TableHead>
//               <TableBody sx={{ backgroundColor: "#fff" }}>
//                 {paginatedRows.map((row, index) => (
//                   <StyledTableRow key={index}>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {row.depot || row.issuing_depot || "-"}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {formatDate(row.entry_date)}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       <Typography sx={{
//                         width: '100%',
//                         maxWidth: '100%',
//                         whiteSpace: 'normal',
//                         wordBreak: 'break-word',
//                       }}
//                       className={styles.inspection_cell}> {row.customer_name || "-"}</Typography>
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {row.product_name || "-"}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {row.product_code || "-"}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {Number(row.po_qty || row.qty || 0).toFixed(2)}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {Number(row.bill_qty || 0).toFixed(2)}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="center"
//                       className={styles.inspection_cell}
//                       sx={{ cursor: "pointer", color: "#1976d2" }}
//                       onClick={() => handleCountClick(row)}
//                     >
//                       {row.no_of_cylinders || 0}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {row.invoice_no || "-"}
//                     </StyledTableCell>
//                     <StyledTableCell isCancelled={row.update_check === 1}>{row.update_check === 1 ? 'cancelled' : ''}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {row.challan_no || "-"}
//                     </StyledTableCell>
//                     <StyledTableCell align="left" className={styles.inspection_cell}>
//                       {formatDate(row.challan_date) || "-"}
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))}
//                 {paginatedRows.length === 0 && (
//                   <StyledTableRow>
//                     <StyledTableCell colSpan={11} align="center">
//                       No data available
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <TablePagination
//             component="div"
//             count={filteredRows.length}
//             page={controller.page}
//             onPageChange={handleChangePage}
//             rowsPerPage={controller.rowsPerPage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </Paper>

//         <Dialog
//           PaperProps={{
//             sx: {
//               minWidth: "90%",
//               maxHeight: "90%",
//             },
//           }}
//           onClose={handleClose}
//           open={openDetail}
//         >
//           <DialogTitle id="customized-dialog-title">
//             {dialogTitle}
//             <IconButton
//               aria-label="close"
//               onClick={handleClose}
//               sx={{
//                 position: "absolute",
//                 right: 8,
//                 top: 8,
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent dividers>
//             <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
//               <Table size="small" stickyHeader className="printable-table">
//                 <TableHead className={styles.table_head_container}>
//                   <StyledTableRow>
//                     <StyledTableCell align="center">Sr No</StyledTableCell>
//                     <StyledTableCell align="left">Cylinder No</StyledTableCell>
//                     <StyledTableCell align="left">Tag No</StyledTableCell>
//                     <StyledTableCell align="left">Owner</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody sx={{ backgroundColor: "#fff" }}>
//                   {dialogData.length > 0 ? (
//                     dialogData.map((row, index) => (
//                       <StyledTableRow key={index}>
//                         <StyledTableCell align="center">{index + 1}</StyledTableCell>
//                         <StyledTableCell className={styles.inspection_cell}>
//                           {row.cylinder_no || "-"}
//                         </StyledTableCell>
//                         <StyledTableCell className={styles.inspection_cell}>
//                           {row.tag_no || "-"}
//                         </StyledTableCell>
//                         <StyledTableCell className={styles.inspection_cell}>
//                           {row.owner || "-"}
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ))
//                   ) : (
//                     <StyledTableRow>
//                       <StyledTableCell colSpan={4} align="center">
//                         No cylinder details available
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </Dialog>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(event, reason) => {
//             if (reason !== "clickaway") {
//               setSuccessMessage("");
//             }
//           }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </Box>
//   );
// };

// export default DailyDistributionReport;


// import React, { useRef, useState, useEffect } from 'react';
// import {
//   Box, Button, Typography, Grid, TableContainer, Table, TableHead, TableBody,
//   Paper, IconButton, Dialog, DialogContent, MenuItem, FormHelperText,
// } from '@mui/material';
// import {
//   Breadcrumb, CTSinput, CTSRinput, StyledTableCell, StyledTableRow,
// } from '../../reusableComponent/Reusables';
// import { useForm, Controller } from 'react-hook-form';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CloseIcon from '@mui/icons-material/Close';
// import { Print } from '@mui/icons-material';
// import styles from '../../../styles.module.css';
// import dayjs from 'dayjs';
// import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
// import daily_distribution_reportService from '../../../services/report/daily_distribution_report.Service';
// import CustomPagination from '../../reusableComponent/CustomPagination';
// import { useSelector } from 'react-redux';

// const printStyles = `
//   @media print {
//     body * { visibility: hidden; }
//     .printable-area, .printable-area * { visibility: visible; }
//     .printable-area {
//       position: absolute; left: 0; top: 0;
//       width: 100%; overflow: visible !important;
//       height: auto !important; max-height: none !important;
//     }
//     .printable-table {
//       width: 100% !important;
//       border-collapse: collapse !important;
//       overflow: visible !important;
//     }
//     .printable-table thead { display: table-header-group; }
//     .printable-table tbody { display: table-row-group; }
//     .MuiPaper-root, .MuiTableContainer-root {
//       overflow: visible !important;
//       max-height: none !important;
//       box-shadow: none !important;
//     }
//     .no-print { display: none !important; }
//     .print-header-info { display: block !important; margin-bottom: 10px; }
//   }
//   .print-header-info { display: none; }
// `;

// const DailyDistributionReport = () => {
//   const defaultRowsPerPage = useSelector(state => state.grn.rows_per_page || 15);

//   const [successMessage, setSuccessMessage]   = useState('');
//   const [displayData, setDisplayData]         = useState([]);
//   const [depots, setDepots]                   = useState([]);
//   const [products, setProducts]               = useState([]);
//   const [customers, setCustomers]             = useState([]);
//   const [loading, setLoading]                 = useState(false);
//   const [openDetail, setOpenDetail]           = useState(false);
//   const [dialogData, setDialogData]           = useState([]);
//   const [selectedRow, setSelectedRow]         = useState(null);
//   const [filterType, setFilterType]           = useState('');
//   const [subBoxValue, setSubBoxValue]         = useState('');
//   const [formValues, setFormValues]           = useState({
//     entry_date_from: '',
//     entry_date_to:   '',
//     filterType:      '',
//     subBox:          '',
//   });

//   const [controller, setController] = useState({ page: 0, rowsPerPage: defaultRowsPerPage });

//   const filterOptions = [
//     { value: 'depot',         label: 'Depot'    },
//     { value: 'product_code',  label: 'Product'  },
//     { value: 'customer_name', label: 'Customer' },
//   ];

//   const totalCount = displayData.length;

//   const getSubBoxOptions = () => {
//     if (!filterType) return [];
//     switch (filterType) {
//       case 'depot':         return [{ value: 'all', label: 'All' }, ...depots.map(d    => ({ value: d,    label: d    }))];
//       case 'product_code':  return [{ value: 'all', label: 'All' }, ...products.map(p  => ({ value: p,    label: p    }))];
//       case 'customer_name': return [{ value: 'all', label: 'All' }, ...customers.map(c => ({ value: c,    label: c    }))];
//       default:              return [];
//     }
//   };
//   const subBoxOptions = getSubBoxOptions();

//   const getSubFilterLabel = () =>
//     filterOptions.find(o => o.value === formValues.filterType)?.label || 'Sub Filter';

//   const getSubFilterDisplayValue = () => {
//     if (!formValues.subBox || formValues.subBox === 'all') return 'All';
//     return formValues.subBox;
//   };

//   const { control, handleSubmit, setValue, formState: { errors } } = useForm({
//     defaultValues: { entry_date_from: '', entry_date_to: '', filterType: '', subBox: '' },
//     resolver: async (data) => {
//       const errors = {};
//       if (!data.entry_date_from) errors.entry_date_from = { message: 'From Date is required' };
//       if (!data.entry_date_to)   errors.entry_date_to   = { message: 'To Date is required'   };
//       if (data.entry_date_from && data.entry_date_to &&
//           dayjs(data.entry_date_to).isBefore(dayjs(data.entry_date_from)))
//         errors.entry_date_to = { message: 'To Date cannot be before From Date' };
//       if (!data.filterType) errors.filterType = { message: 'Filter Type is required' };
//       if (!data.subBox)     errors.subBox     = { message: 'Sub Filter is required'  };
//       return { values: data, errors };
//     },
//   });

//   useEffect(() => {
//     const styleSheet = document.createElement('style');
//     styleSheet.type = 'text/css';
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);
//     return () => { document.head.removeChild(styleSheet); };
//   }, []);

//   const handleShow = async (formData) => {
//     try {
//       setLoading(true);
//       setDisplayData([]);
//       setController({ page: 0, rowsPerPage: defaultRowsPerPage });

//       setFormValues({
//         entry_date_from: formData.entry_date_from,
//         entry_date_to:   formData.entry_date_to,
//         filterType:      formData.filterType,
//         subBox:          formData.subBox,
//       });

//       const response = await daily_distribution_reportService.getdailydistributionrepotlist({
//         page: 0, size: 999, searchKey: '',
//         entry_date_from: formData.entry_date_from,
//         entry_date_to:   formData.entry_date_to,
//       });
//       const fetchedData = response || [];

//       // Extract unique filter options from fetched data
//       setDepots(   [...new Set(fetchedData.map(r => r.depot         || r.issuing_depot).filter(Boolean))]);
//       setProducts( [...new Set(fetchedData.map(r => r.product_code).filter(Boolean))]);
//       setCustomers([...new Set(fetchedData.map(r => r.customer_name).filter(Boolean))]);

//       // Client-side filter
//       let filteredData = fetchedData;
//       if (formData.filterType && formData.subBox && formData.subBox !== 'all') {
//         filteredData = filteredData.filter(r => {
//           const fieldMap = { depot: r.depot || r.issuing_depot, product_code: r.product_code, customer_name: r.customer_name };
//           return fieldMap[formData.filterType] === formData.subBox;
//         });
//       }
//       setDisplayData(filteredData);
//     } catch (error) {
//       console.error(error);
//       setSuccessMessage('Error fetching data');
//       setDisplayData([]);
//     } finally { setLoading(false); }
//   };

//   const handleCylinderClick = (row) => {
//     setSelectedRow(row);
//     setDialogData(row.cylinders || []);
//     setOpenDetail(true);
//   };
//   const handleClose = () => { setOpenDetail(false); setDialogData([]); setSelectedRow(null); };

//   const handlePrint = () => window.print();

//   const handleChangePage        = (e, newPage) => setController(prev => ({ ...prev, page: newPage }));
//   const handleChangeRowsPerPage = (e)          => setController({ rowsPerPage: parseInt(e.target.value, 10), page: 0 });

//   const dateConversion = (date) => {
//     if (!date) return '';
//     const d  = new Date(date);
//     return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
//   };

//   const cylinderHeaders = ['Sr No', 'Cylinder No', 'Tag No', 'Owner'];

//   const mainTableHeaders = [
//     'Sr No', 'Date', 'Issuing Depot', 'Customer Name',
//     'Product Name', 'Product Code', 'PO Qty', 'Del Qty',
//     'No of Cylinders', 'Invoice No', 'Flag', 'Challan No', 'Challan Date',
//   ];

//   return (
//     <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: 'Daily Distribution Report' }]} />
//         <Typography className={styles.header_txt}>DAILY DISTRIBUTION REPORT</Typography>

//         {/* ── Filter Row ── */}
//         <Box
//           className="no-print"
//           component="form"
//           onSubmit={handleSubmit(handleShow)}
//           sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: '12px', mb: 2, width: '100%' }}
//         >
//           {/* From Date */}
//           <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
//               From Date <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <Controller name="entry_date_from" control={control} render={({ field }) => (
//               <CTSRinput size="small" fullWidth type="date" {...field}
//                 error={!!errors.entry_date_from} helperText={errors.entry_date_from?.message}
//                 InputProps={{ className: styles.CTSinput_Box }} />
//             )} />
//           </Box>

//           {/* To Date */}
//           <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
//               To Date <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <Controller name="entry_date_to" control={control} render={({ field }) => (
//               <CTSRinput size="small" fullWidth type="date" {...field}
//                 error={!!errors.entry_date_to} helperText={errors.entry_date_to?.message}
//                 InputProps={{ className: styles.CTSinput_Box }} />
//             )} />
//           </Box>

//           {/* Filter By */}
//           <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
//               Filter By <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <Controller name="filterType" control={control} render={({ field }) => (
//               <CTSinput select size="small" fullWidth {...field}
//                 onChange={(e) => { field.onChange(e); setFilterType(e.target.value); setSubBoxValue(''); setValue('subBox', ''); }}
//                 error={!!errors.filterType}
//                 InputProps={{ className: styles.CTSinput_Box }}
//               >
//                 <MenuItem value=""><em>Select Filter</em></MenuItem>
//                 {filterOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
//               </CTSinput>
//             )} />
//             {errors.filterType && <FormHelperText error>{errors.filterType.message}</FormHelperText>}
//           </Box>

//           {/* Sub Filter */}
//           <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
//               {filterOptions.find(o => o.value === filterType)?.label || 'Sub Filter'} <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <Controller name="subBox" control={control} render={({ field }) => (
//               <CTSinput select size="small" fullWidth {...field}
//                 disabled={!filterType}
//                 onChange={(e) => { field.onChange(e); setSubBoxValue(e.target.value); }}
//                 error={!!errors.subBox}
//                 InputProps={{ className: styles.CTSinput_Box }}
//               >
//                 <MenuItem value=""><em>Select Option</em></MenuItem>
//                 {subBoxOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
//               </CTSinput>
//             )} />
//             {errors.subBox && <FormHelperText error>{errors.subBox.message}</FormHelperText>}
//           </Box>

//           {/* Show + Print buttons */}
//           <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '8px', flex: '0 0 auto' }}>
//             <Button
//               variant="contained" startIcon={<VisibilityIcon />} type="submit"
//               className={styles.addnew_btn}
//               disabled={loading || !filterType || !subBoxValue}
//               size="small" sx={{ height: '30px', whiteSpace: 'nowrap' }}
//             >
//               <Typography className={styles.addnew_btn_txt}>Show</Typography>
//             </Button>
//             <Button
//               variant="outlined" startIcon={<Print />} onClick={handlePrint}
//               disabled={displayData.length === 0} size="small"
//               sx={{ whiteSpace: 'nowrap', height: '30px' }}
//             >
//               Print
//             </Button>
//           </Box>
//         </Box>

//         {/* ── Main Table ── */}
//         <Grid item xs={12}>
//           <Paper sx={{ width: '100%' }}>
//             <div className="printable-area">

//               {/* Print Header */}
//               <div className="print-header-info" style={{ marginBottom: '20px' }}>
//                 <Typography variant="h4" align="left" sx={{ fontWeight: 'bold' }}>Daily Distribution Report</Typography>
//                 <Typography variant="body1" align="left" sx={{ marginTop: 1 }}>
//                   From: {dateConversion(formValues.entry_date_from)} &nbsp;|&nbsp;
//                   To: {dateConversion(formValues.entry_date_to)} &nbsp;|&nbsp;
//                   {getSubFilterLabel()}: {getSubFilterDisplayValue()}
//                 </Typography>
//               </div>

//               <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
//                 <Table size="small" stickyHeader className="printable-table">
//                   <TableHead>
//                     <StyledTableRow>
//                       {mainTableHeaders.map(h => (
//                         <StyledTableCell key={h} sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>{h}</StyledTableCell>
//                       ))}
//                     </StyledTableRow>
//                   </TableHead>
//                   <TableBody sx={{ backgroundColor: '#fff' }}>
//                     {loading ? (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={mainTableHeaders.length} align="center">
//                           <Typography>Loading data...</Typography>
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ) : displayData.length === 0 ? (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={mainTableHeaders.length} align="center">
//                           <Typography>No data found</Typography>
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ) : (
//                       displayData
//                         .slice(controller.page * controller.rowsPerPage, (controller.page + 1) * controller.rowsPerPage)
//                         .map((row, index) => (
//                           <StyledTableRow key={index}>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {controller.page * controller.rowsPerPage + index + 1}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {dateConversion(row.entry_date)}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {row.depot || row.issuing_depot || '-'}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}
//                               sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '160px' }}>
//                               {row.customer_name || '-'}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {row.product_name || '-'}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {row.product_code || '-'}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {Number(row.po_qty || row.qty || 0).toFixed(2)}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {Number(row.bill_qty || row.del_qty || 0).toFixed(2)}
//                             </StyledTableCell>

//                             {/* No of Cylinders — clickable */}
//                             <StyledTableCell
//                               onClick={() => handleCylinderClick(row)}
//                               sx={{ cursor: 'pointer' }}
//                             >
//                               <Typography sx={{ fontSize: '12px', fontWeight: 'bold', color: '#1976d2 !important', textDecoration: 'underline' }}>
//                                 {row.no_of_cylinders || 0}
//                               </Typography>
//                             </StyledTableCell>

//                             <StyledTableCell className={styles.inspection_cell}>
//                               {row.invoice_no || '-'}
//                             </StyledTableCell>
//                             <StyledTableCell isCancelled={row.update_check === 1}>
//                               {row.update_check === 1 ? 'Cancelled' : ''}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {row.challan_no || '-'}
//                             </StyledTableCell>
//                             <StyledTableCell className={styles.inspection_cell}>
//                               {dateConversion(row.challan_date)}
//                             </StyledTableCell>
//                           </StyledTableRow>
//                         ))
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </div>

//             <CustomPagination
//               page={controller.page}
//               rowsPerPage={controller.rowsPerPage}
//               totalCount={totalCount}
//               onPageChange={(newPage) => handleChangePage(null, newPage)}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//               className="no-print"
//             />
//           </Paper>
//         </Grid>

//         {/* ── Snackbar ── */}
//         <ReusableSnackbar
//           open={!!successMessage} onClose={() => setSuccessMessage('')}
//           message={successMessage} autoHideDuration={2000}
//           vertical="top" horizontal="right" className="no-print"
//         />

//         {/* ── Detail Dialog ── */}
//         <Dialog
//           open={openDetail} onClose={handleClose} maxWidth={false} className="no-print"
//           sx={{
//             '& .MuiDialog-paper': {
//               margin: 'auto', width: '92vw', maxHeight: '85vh',
//               boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
//               overflow: 'hidden', fontFamily: "'Inter', Arial, sans-serif",
//             },
//           }}
//         >
//           {/* Header */}
//           <Box sx={{ background: '#1C3A5E', padding: '14px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#fff', letterSpacing: '0.5px', fontFamily: "'Inter', Arial, sans-serif" }}>
//               DAILY DISTRIBUTION DETAILS
//             </Typography>
//             <IconButton onClick={handleClose} sx={{ color: '#fff', p: 0.5 }}>
//               <CloseIcon fontSize="small" />
//             </IconButton>
//           </Box>

//           <DialogContent sx={{ padding: '20px 24px', background: '#F4F7FB', overflowY: 'auto' }}>

//             {/* ── Distribution Info Card ── */}
//             <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden', mb: 2.5 }}>
//               <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
//                 <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
//                   📋 Distribution Information
//                 </Typography>
//               </Box>
//               <Grid container>
//                 {[
//                   { label: 'Invoice No',       value: selectedRow?.invoice_no,                        border: true,  bottom: true  },
//                   { label: 'Date',             value: dateConversion(selectedRow?.entry_date),        border: true,  bottom: true  },
//                   { label: 'Customer Name',    value: selectedRow?.customer_name,                     border: true,  bottom: true  },
//                   { label: 'Issuing Depot',    value: selectedRow?.depot || selectedRow?.issuing_depot, border: false, bottom: true  },
//                   { label: 'Product Name',     value: selectedRow?.product_name,                      border: true,  bottom: false },
//                   { label: 'Product Code',     value: selectedRow?.product_code,                      border: true,  bottom: false },
//                   { label: 'Challan No',       value: selectedRow?.challan_no,                        border: true,  bottom: false },
//                   { label: 'No of Cylinders',  value: selectedRow?.no_of_cylinders,                   border: false, bottom: false },
//                 ].map(({ label, value, border, bottom }) => (
//                   <Grid key={label} item xs={12} sm={6} md={3}
//                     sx={{ borderRight: border ? '1px solid #EDF2F7' : 'none', borderBottom: bottom ? '1px solid #EDF2F7' : 'none', padding: '12px 16px' }}
//                   >
//                     <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.6px', mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
//                       {label}
//                     </Typography>
//                     <Typography sx={{ fontSize: '14px', fontWeight: label === 'Invoice No' ? 700 : 600, color: label === 'Invoice No' ? '#1C3A5E' : '#2D3748', fontFamily: "'Inter', Arial, sans-serif" }}>
//                       {value || 'N/A'}
//                     </Typography>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Box>

//             {/* ── Cylinder Details Table ── */}
//             <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
//               <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
//                 <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
//                   🛢️ Cylinder Details
//                 </Typography>
//               </Box>
//               <TableContainer sx={{ maxHeight: '350px' }}>
//                 <Table size="small" stickyHeader>
//                   <TableHead>
//                     <StyledTableRow>
//                       {cylinderHeaders.map(header => (
//                         <StyledTableCell key={header} align="center"
//                           sx={{ backgroundColor: '#1C3A5E !important', color: '#fff !important', fontFamily: "'Inter', Arial, sans-serif", fontWeight: 700, fontSize: '11px', padding: '10px 8px', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255,255,255,0.1)' }}
//                         >
//                           {header}
//                         </StyledTableCell>
//                       ))}
//                     </StyledTableRow>
//                   </TableHead>
//                   <TableBody>
//                     {dialogData.length > 0 ? (
//                       dialogData.map((row, index) => (
//                         <StyledTableRow key={index}
//                           sx={{ backgroundColor: index % 2 === 0 ? '#fff' : '#F8FAFC', '&:hover': { backgroundColor: '#EBF4FF' } }}
//                         >
//                           {[index + 1, row.cylinder_no || 'N/A', row.tag_no || 'N/A', row.owner || 'N/A'].map((val, ci) => (
//                             <StyledTableCell key={ci} align="center"
//                               sx={{ fontSize: '11px', fontFamily: "'Inter', Arial, sans-serif", color: '#2D3748', padding: '8px 6px', borderBottom: '1px solid #EDF2F7', whiteSpace: 'nowrap' }}
//                             >
//                               {val}
//                             </StyledTableCell>
//                           ))}
//                         </StyledTableRow>
//                       ))
//                     ) : (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={cylinderHeaders.length} align="center"
//                           sx={{ py: 5, fontSize: '13px', color: '#A0AEC0', fontFamily: "'Inter', Arial, sans-serif" }}
//                         >
//                           No cylinder details available
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Box>
//           </DialogContent>

//           {/* Footer */}
//           <Box sx={{ padding: '12px 24px', background: '#F8FAFC', borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'flex-end' }}>
//             <Button onClick={handleClose}
//               sx={{ background: '#E53E3E', color: '#fff', fontSize: '13px', fontWeight: 600, textTransform: 'none', padding: '7px 20px', borderRadius: '8px', fontFamily: "'Inter', Arial, sans-serif", '&:hover': { background: '#971f16' } }}
//             >
//               Close
//             </Button>
//           </Box>
//         </Dialog>

//       </Box>
//     </Box>
//   );
// };

// export default DailyDistributionReport;

import React, { useRef, useState, useEffect } from 'react';
import {
  Box, Button, Typography, Grid, TableContainer, Table, TableHead, TableBody,
  Paper, IconButton, Dialog, DialogContent, MenuItem, FormHelperText,
} from '@mui/material';
import {
  Breadcrumb, CTSinput, CTSRinput, StyledTableCell, StyledTableRow,
} from '../../reusableComponent/Reusables';
import { useForm, Controller } from 'react-hook-form';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { Print } from '@mui/icons-material';
import styles from '../../../styles.module.css';
import dayjs from 'dayjs';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
import CustomPagination from '../../reusableComponent/CustomPagination';
import { useSelector } from 'react-redux';
import daily_distribution_reportService from '../../../services/report/daily_distribution_report.Service';

const printStyles = `
  @media print {
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .printable-table {
      width: 100% !important;
      border-collapse: collapse !important;
      overflow: visible !important;
    }
    .printable-table thead { display: table-header-group; }
    .printable-table tbody { display: table-row-group; }
    .MuiPaper-root, .MuiTableContainer-root {
      overflow: visible !important;
      max-height: none !important;
      box-shadow: none !important;
    }
    .no-print { display: none !important; }
    .print-header-info { display: block !important; margin-bottom: 10px; }
  }
  .print-header-info { display: none; }
`;

const DailyDistributionReport = () => {
  const defaultRowsPerPage = useSelector(state => state.grn.rows_per_page || 15);

  const [successMessage, setSuccessMessage] = useState('');
  const [displayData, setDisplayData] = useState([]);
  const [depots, setDepots]     = useState([]);
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading]   = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [dialogData, setDialogData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filterType, setFilterType]   = useState('depot');
  const [subBoxValue, setSubBoxValue] = useState('');
  const [formValues, setFormValues]   = useState({
    entry_date_from: '',
    entry_date_to:   '',
    filterType:      'depot',
    subBox:          '',
  });

  const [controller, setController] = useState({ page: 0, rowsPerPage: defaultRowsPerPage });

  const filterOptions = [
    { value: 'depot',         label: 'Depot'    },
    { value: 'product_code',  label: 'Product'  },
    { value: 'customer_name', label: 'Customer' },
  ];

  const totalCount = displayData.length;

  const getSubBoxOptions = () => {
    switch (filterType) {
      case 'depot':         return [{ value: 'all', label: 'All' }, ...depots.map(d    => ({ value: d,              label: d              }))];
      case 'product_code':  return [{ value: 'all', label: 'All' }, ...products.map(p  => ({ value: p,              label: p              }))];
      case 'customer_name': return [{ value: 'all', label: 'All' }, ...customers.map(c => ({ value: c,              label: c              }))];
      default:              return [];
    }
  };
  const subBoxOptions = getSubBoxOptions();

  const getSubFilterLabel        = () => filterOptions.find(o => o.value === formValues.filterType)?.label || 'Sub Filter';
  const getSubFilterDisplayValue = () => {
    if (!formValues.subBox || formValues.subBox === 'all') return 'All';
    return formValues.subBox;
  };

  const { control, handleSubmit, setValue, formState: { errors } } = useForm({
defaultValues: { 
  entry_date_from: dayjs().format('YYYY-MM-DD'),  // ← today
  entry_date_to: dayjs().format('YYYY-MM-DD'),    // ← today
  filterType: 'depot', 
  subBox: '' 
},
    resolver: async (data) => {
      const errors = {};
      if (!data.entry_date_from) errors.entry_date_from = { message: 'From Date is required' };
      if (!data.entry_date_to)   errors.entry_date_to   = { message: 'To Date is required'   };
      if (data.entry_date_from && data.entry_date_to && dayjs(data.entry_date_to).isBefore(dayjs(data.entry_date_from)))
        errors.entry_date_to = { message: 'To Date cannot be before From Date' };
      if (!data.filterType) errors.filterType = { message: 'Filter Type is required' };
      if (!data.subBox)     errors.subBox     = { message: 'Sub Filter is required'  };
      return { values: data, errors };
    },
  });

  // inject print styles once
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  const handleShow = async (formData) => {
    try {
      setLoading(true);
      setDisplayData([]);
      setController({ page: 0, rowsPerPage: defaultRowsPerPage });

      setFormValues({
        entry_date_from: formData.entry_date_from,
        entry_date_to:   formData.entry_date_to,
        filterType:      formData.filterType,
        subBox:          formData.subBox,
      });

      const params = {
        page: 0, size: 999, searchKey: '',
        entry_date_from: formData.entry_date_from,
        entry_date_to:   formData.entry_date_to,
        filterType:      formData.filterType,
        subBox:          formData.subBox !== 'all' ? formData.subBox : '',
      };
      const response    = await daily_distribution_reportService.getdailydistributionrepotlist(params);
      const fetchedData = response || [];

      const uniqueDepots    = [...new Set(fetchedData.map(r => r.depot))].filter(Boolean);
      const uniqueProducts  = [...new Set(fetchedData.map(r => r.product_code))].filter(Boolean);
      const uniqueCustomers = [...new Set(fetchedData.map(r => r.customer_name))].filter(Boolean);
      setDepots(uniqueDepots);
      setProducts(uniqueProducts);
      setCustomers(uniqueCustomers);

      const flattenedData = fetchedData.map((item, index) => ({
        sr_no:           index + 1,
        challan_no:      item.challan_no      || 'N/A',
        challan_date:    item.challan_date     || null,
        entry_date:      item.entry_date       || null,
        depot:           item.depot            || item.issuing_depot || 'N/A',
        customer_name:   item.customer_name    || 'N/A',
        product_name:    item.product_name     || 'N/A',
        product_code:    item.product_code     || 'N/A',
        po_qty:          item.po_qty           || item.qty  || 0,
        del_qty:         item.bill_qty         || item.del_qty || 0,
        no_of_cylinders: item.no_of_cylinders  || 0,
        invoice_no:      item.invoice_no       || 'N/A',
        update_check:    item.update_check,
        cylinders:       item.cylinders        || [],
      }));

      // client-side filter
      let filtered = flattenedData;
      if (formData.filterType && formData.subBox && formData.subBox !== 'all') {
        filtered = filtered.filter(r => {
          switch (formData.filterType) {
            case 'depot':         return r.depot         === formData.subBox;
            case 'product_code':  return r.product_code  === formData.subBox;
            case 'customer_name': return r.customer_name === formData.subBox;
            default:              return true;
          }
        });
      }
      setDisplayData(filtered);
    } catch (error) {
      console.error(error);
      setSuccessMessage('Error fetching data');
      setDisplayData([]);
    } finally { setLoading(false); }
  };

  const handlePrint = () => { window.print(); };

  const handleChallanClick = (row) => {
    setSelectedRow(row);
    setDialogData(row.cylinders || []);
    setOpenDetail(true);
  };
  const handleClose = () => { setOpenDetail(false); setDialogData([]); setSelectedRow(null); };

  const handleChangePage        = (e, newPage) => setController(prev => ({ ...prev, page: newPage }));
  const handleChangeRowsPerPage = (e)          => setController({ rowsPerPage: parseInt(e.target.value, 10), page: 0 });

  const dateConversion = (date) => {
    if (!date) return '';
    const d  = new Date(date);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
  };

  const cylinderHeaders = ['Sr No', 'Cylinder No', 'Tag No', 'Owner'];

  const mainHeaders = [
    'Challan No', 'Date', 'Issuing Depot', 'Customer Name',
    'Product Name', 'Product Code', 'PO Qty', 'Del Qty',
    'No of Cylinders', 'Invoice No', 'Flag',
  ];

  return (
    <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: 'Daily Distribution Report' }]} />
        <Typography className={styles.header_txt}>DAILY DISTRIBUTION SUMMARY</Typography>

        {/* ── Filter Row ── */}
        <Box
          className="no-print"
          component="form"
          onSubmit={handleSubmit(handleShow)}
          sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: '12px', mb: 2, width: '100%' }}
        >
          {/* From Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              From Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="entry_date_from" control={control} render={({ field }) => (
              <CTSRinput size="small" fullWidth type="date" {...field}
                error={!!errors.entry_date_from} helperText={errors.entry_date_from?.message}
                InputProps={{ className: styles.CTSinput_Box }} />
            )} />
          </Box>

          {/* To Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              To Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="entry_date_to" control={control} render={({ field }) => (
              <CTSRinput size="small" fullWidth type="date" {...field}
                error={!!errors.entry_date_to} helperText={errors.entry_date_to?.message}
                InputProps={{ className: styles.CTSinput_Box }} />
            )} />
          </Box>

          {/* Filter By */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              Filter By <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="filterType" control={control} render={({ field }) => (
              <CTSinput select size="small" fullWidth {...field}
                onChange={(e) => { field.onChange(e); setFilterType(e.target.value); setSubBoxValue(''); setValue('subBox', ''); }}
                error={!!errors.filterType}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                <MenuItem value=""><em>Select Filter</em></MenuItem>
                {filterOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
              </CTSinput>
            )} />
            {errors.filterType && <FormHelperText error>{errors.filterType.message}</FormHelperText>}
          </Box>

          {/* Sub Filter */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              {getSubFilterLabel()} <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="subBox" control={control} render={({ field }) => (
              <CTSinput select size="small" fullWidth {...field}
                disabled={!filterType}
                onChange={(e) => { field.onChange(e); setSubBoxValue(e.target.value); }}
                error={!!errors.subBox}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                {/* <MenuItem value=""><em>Select Option</em></MenuItem> */}
                {subBoxOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
              </CTSinput>
            )} />
            {errors.subBox && <FormHelperText error>{errors.subBox.message}</FormHelperText>}
          </Box>

          {/* Show + Print */}
          <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '8px', flex: '0 0 auto' }}>
            <Button
              variant="contained" startIcon={<VisibilityIcon />} type="submit"
              className={styles.addnew_btn}
              disabled={loading || !filterType || !subBoxValue}
              size="small" sx={{ height: '30px', whiteSpace: 'nowrap' }}
            >
              <Typography className={styles.addnew_btn_txt}>Show</Typography>
            </Button>
            <Button
              variant="outlined" startIcon={<Print />} onClick={handlePrint}
              disabled={displayData.length === 0} size="small"
              sx={{ whiteSpace: 'nowrap', height: '30px' }}
            >
              Print
            </Button>
          </Box>
        </Box>

        {/* ── Main Table ── */}
        <Grid item xs={12}>
          <Paper sx={{ width: '100%' }}>
            <div className="printable-area">
              <div className="print-header-info" style={{ marginBottom: '20px' }}>
                <Typography variant="h4" align="left" sx={{ fontWeight: 'bold' }}>Daily Distribution Report</Typography>
                <Typography variant="body1" align="left" sx={{ marginTop: 1 }}>
                  From: {dateConversion(formValues.entry_date_from)} &nbsp;|&nbsp;
                  To: {dateConversion(formValues.entry_date_to)} &nbsp;|&nbsp;
                  {getSubFilterLabel()}: {getSubFilterDisplayValue()}
                </Typography>
              </div>

              <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                <Table size="small" stickyHeader className="printable-table" sx={{ tableLayout: 'fixed', minWidth: '1100px' }}>
                  <TableHead>
                    <StyledTableRow>
                      {[
                        { label: 'Challan No',       width: '130px' },
                        { label: 'Date',             width: '90px'  },
                        { label: 'Issuing Depot',    width: '110px' },
                        { label: 'Customer Name',    width: '200px' },
                        { label: 'Product Name',     width: '120px' },
                        { label: 'Product Code',     width: '100px' },
                        { label: 'PO Qty',           width: '70px'  },
                        { label: 'Del Qty',          width: '70px'  },
                        { label: 'No of Cylinders',  width: '110px' },
                        { label: 'Invoice No',       width: '110px' },
                        { label: 'Flag',             width: '70px'  },
                      ].map(({ label, width }) => (
                        <StyledTableCell key={label} sx={{ textAlign: 'left !important', paddingLeft: '5px', whiteSpace: 'nowrap', width, minWidth: width }}>{label}</StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: '#fff' }}>
                    {loading ? (
                      <StyledTableRow><StyledTableCell colSpan={mainHeaders.length} align="center"><Typography>Loading data...</Typography></StyledTableCell></StyledTableRow>
                    ) : displayData.length === 0 ? (
                      <StyledTableRow><StyledTableCell colSpan={mainHeaders.length} align="center"><Typography>No data found</Typography></StyledTableCell></StyledTableRow>
                    ) : (
                      displayData
                        .slice(controller.page * controller.rowsPerPage, (controller.page + 1) * controller.rowsPerPage)
                        .map((row, index) => (
                          <StyledTableRow key={index}>
                            {/* Challan No — clickable, opens detail dialog */}
                            <StyledTableCell onClick={() => handleChallanClick(row)} sx={{ whiteSpace: 'nowrap' }}>
                              <Typography sx={{ fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', color: '#1976d2 !important', textDecoration: 'underline' }}>
                                {row.challan_no}
                              </Typography>
                            </StyledTableCell>

                            {/* Date */}
                            <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: 'nowrap' }}>{dateConversion(row.entry_date)}</StyledTableCell>

                            {/* Issuing Depot */}
                            <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: 'nowrap' }}>{row.depot}</StyledTableCell>

                            {/* Customer Name */}
                            <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: 'normal', wordBreak: 'break-word', minWidth: '200px', maxWidth: '200px', overflow: 'hidden' }}>
                              {row.customer_name}
                            </StyledTableCell>

                            {/* Product Name */}
                            <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: 'nowrap', minWidth: '120px' }}>{row.product_name}</StyledTableCell>

                            {/* Product Code */}
                            <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: 'nowrap' }}>{row.product_code}</StyledTableCell>

                            {/* PO Qty */}
                            <StyledTableCell className={styles.inspection_cell} align="left" sx={{ whiteSpace: 'nowrap' }}>
                              {Number(row.po_qty || 0).toFixed(2)}
                            </StyledTableCell>

                            {/* Del Qty */}
                            <StyledTableCell className={styles.inspection_cell} align="left" sx={{ whiteSpace: 'nowrap' }}>
                              {Number(row.del_qty || 0).toFixed(2)}
                            </StyledTableCell>

                            {/* No of Cylinders — plain, no click */}
                            <StyledTableCell className={styles.inspection_cell} align="left" sx={{ whiteSpace: 'nowrap' }}>
                              {row.no_of_cylinders}
                            </StyledTableCell>

                            {/* Invoice No */}
                            <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: 'nowrap' }}>{row.invoice_no}</StyledTableCell>

                            {/* Flag */}
                            <StyledTableCell isCancelled={row.update_check === 1} className={styles.inspection_cell} sx={{ whiteSpace: 'nowrap' }}>
                              {row.update_check === 1 ? 'Cancelled' : ''}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <CustomPagination
              page={controller.page}
              rowsPerPage={controller.rowsPerPage}
              totalCount={totalCount}
              onPageChange={(newPage) => handleChangePage(null, newPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="no-print"
            />
          </Paper>
        </Grid>

        {/* ── Snackbar ── */}
        <ReusableSnackbar
          open={!!successMessage} onClose={() => setSuccessMessage('')}
          message={successMessage} autoHideDuration={2000}
          vertical="top" horizontal="right" className="no-print"
        />

        {/* ── Detail Dialog ── */}
        <Dialog
          open={openDetail} onClose={handleClose} maxWidth={false} className="no-print"
          sx={{
            '& .MuiDialog-paper': {
              margin: 'auto', width: '92vw', maxHeight: '85vh',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              overflow: 'hidden', fontFamily: "'Inter', Arial, sans-serif",
            },
          }}
        >
          {/* Header */}
          <Box sx={{ background: '#1C3A5E', padding: '14px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#fff', letterSpacing: '0.5px', fontFamily: "'Inter', Arial, sans-serif" }}>
              DAILY DISTRIBUTION DETAILS
            </Typography>
            <IconButton onClick={handleClose} sx={{ color: '#fff', p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: '20px 24px', background: '#F4F7FB', overflowY: 'auto' }}>

            {/* ── Challan Info Card ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden', mb: 2.5 }}>
              <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  📋 Challan Information
                </Typography>
              </Box>
              <Grid container>
                {[
                  { label: 'Challan No',       value: selectedRow?.challan_no,                    border: true,  bottom: true  },
                  { label: 'Challan Date',      value: dateConversion(selectedRow?.challan_date),  border: true,  bottom: true  },
                  { label: 'Date',              value: dateConversion(selectedRow?.entry_date),    border: true,  bottom: true  },
                  { label: 'Issuing Depot',     value: selectedRow?.depot,                         border: false, bottom: true  },
                  { label: 'Customer Name',     value: selectedRow?.customer_name,                 border: true,  bottom: false },
                  { label: 'Product Name',      value: selectedRow?.product_name,                  border: true,  bottom: false },
                  { label: 'Product Code',      value: selectedRow?.product_code,                  border: true,  bottom: false },
                  { label: 'No of Cylinders',   value: selectedRow?.no_of_cylinders,               border: false, bottom: false },
                  { label: 'PO Qty',            value: Number(selectedRow?.po_qty || 0).toFixed(2), border: true, bottom: false },
                  { label: 'Del Qty',           value: Number(selectedRow?.del_qty || 0).toFixed(2), border: true, bottom: false },
                  { label: 'Invoice No',        value: selectedRow?.invoice_no,                    border: true,  bottom: false },
                  { label: 'Flag',              value: selectedRow?.update_check === 1 ? 'Cancelled' : '-', border: false, bottom: false },
                ].map(({ label, value, border, bottom }) => (
                  <Grid key={label} item xs={12} sm={6} md={3}
                    sx={{ borderRight: border ? '1px solid #EDF2F7' : 'none', borderBottom: bottom ? '1px solid #EDF2F7' : 'none', padding: '12px 16px' }}
                  >
                    <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.6px', mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      {label}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: label === 'Challan No' ? 700 : 600, color: label === 'Challan No' ? '#1C3A5E' : '#2D3748', fontFamily: "'Inter', Arial, sans-serif" }}>
                      {value || 'N/A'}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              {/* <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  🛢️ Cylinder Details
                </Typography>
              </Box> */}
              <TableContainer sx={{ maxHeight: '350px' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {cylinderHeaders.map(header => (
                        <StyledTableCell key={header} align="center"
                          sx={{ backgroundColor: '#1C3A5E !important', color: '#fff !important', fontFamily: "'Inter', Arial, sans-serif", fontWeight: 700, fontSize: '11px', padding: '10px 8px', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255,255,255,0.1)' }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {dialogData.length > 0 ? (
                      dialogData.map((row, index) => (
                        <StyledTableRow key={index}
                          sx={{ backgroundColor: index % 2 === 0 ? '#fff' : '#F8FAFC', '&:hover': { backgroundColor: '#EBF4FF' } }}
                        >
                          {[index + 1, row.cylinder_no || 'N/A', row.tag_no || 'N/A', row.owner || 'N/A'].map((val, ci) => (
                            <StyledTableCell key={ci} align="center"
                              sx={{ fontSize: '11px', fontFamily: "'Inter', Arial, sans-serif", color: '#2D3748', padding: '8px 6px', borderBottom: '1px solid #EDF2F7', whiteSpace: 'nowrap' }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={cylinderHeaders.length} align="center"
                          sx={{ py: 5, fontSize: '13px', color: '#A0AEC0', fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </DialogContent>

          {/* Footer */}
          <Box sx={{ padding: '12px 24px', background: '#F8FAFC', borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleClose}
              sx={{ background: '#E53E3E', color: '#fff', fontSize: '13px', fontWeight: 600, textTransform: 'none', padding: '7px 20px', borderRadius: '8px', fontFamily: "'Inter', Arial, sans-serif", '&:hover': { background: '#971f16' } }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

      </Box>
    </Box>
  );
};

export default DailyDistributionReport;